import { createElement } from 'react';
import { _ as _objectWithoutProperties, e as _toPropertyKey } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import isNil from 'lodash.isnil';

let FilterPanelTabs = /*#__PURE__*/function (FilterPanelTabs) {
  FilterPanelTabs["BASIC"] = "basic";
  FilterPanelTabs["CUSTOM"] = "custom";
  return FilterPanelTabs;
}({});
const removeField = (obj, field) => {
  const objWithRemovedField = _objectWithoutProperties(obj, [field].map(_toPropertyKey));
  return objWithRemovedField;
};
const getTotalNumberOfFilters = (filters, fields) => {
  const fieldsToCount = fields ? [fields].flat() : Object.keys(filters);
  return fieldsToCount.reduce((sum, field) => {
    const values = filters[field];
    if (!values) {
      return sum;
    }
    if (Array.isArray(values)) {
      return sum + values.length;
    }
    return sum + 1;
  }, 0);
};
const formatFilterRange = (min, max) => {
  const isMinDefined = !isNil(min);
  const isMaxDefined = !isNil(max);
  if (isMinDefined && isMaxDefined) {
    return `${min}-${max}`;
  }
  if (isMinDefined) {
    return `${min}-...`;
  }
  return `...-${max}`;
};
const convertFilterValueToString = (value, fieldMetadata) => {
  if (fieldMetadata.valueToString) {
    return fieldMetadata.valueToString(value);
  }
  if (value.label) {
    return value.label;
  }
  if (!isNil(value.min) || !isNil(value.max)) {
    return formatFilterRange(value.min, value.max);
  }
  return value;
};
const getFilterPanelChipContent = ({
  field,
  value,
  fieldsMetadata,
  theme
}) => {
  const label = fieldsMetadata[field].label || field;
  return /*#__PURE__*/createElement(Div, null, /*#__PURE__*/createElement(Span, null, `${label}: `), /*#__PURE__*/createElement(Span, {
    fontWeight: theme.typography.fontWeightBold
  }, convertFilterValueToString(value, fieldsMetadata[field])));
};

export { FilterPanelTabs, convertFilterValueToString, formatFilterRange, getFilterPanelChipContent, getTotalNumberOfFilters, removeField };
